export default __webpack_public_path__ + "static/12-eef29a1625f6b6b87d8aa60feea50e7a.png";